// Transforme un texte libre en HTML sûr : échappe d'abord les caractères
// HTML (<, >, &) pour empêcher toute injection (XSS), puis transforme les URLs
// en liens cliquables. À utiliser avec dangerouslySetInnerHTML.
export function linkify(text) {
  if (!text) return "";

  const escaped = String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

  return escaped.replace(
    /(https?:\/\/[^\s]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer" ' +
    'style="color:#0077b6;text-decoration:underline;' +
    'overflow-wrap:anywhere;word-break:break-word;">$1</a>'
  );
}
